/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Woher die Datensaetze kommen. CURRENT = die Unterdatensaetze des
 * geoeffneten Datensatzes (der Normalfall). FIXED = die eines fest
 * gewaehlten Datensatzes, etwa der Anlage.
 * @export
 */
export const DatabaseSubDbListSource = {
    Current: 'CURRENT',
    Fixed: 'FIXED'
} as const;
export type DatabaseSubDbListSource = typeof DatabaseSubDbListSource[keyof typeof DatabaseSubDbListSource];


export function DatabaseSubDbListSourceFromJSON(json: any): DatabaseSubDbListSource {
    return DatabaseSubDbListSourceFromJSONTyped(json, false);
}

export function DatabaseSubDbListSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSubDbListSource {
    return json as DatabaseSubDbListSource;
}

export function DatabaseSubDbListSourceToJSON(value?: DatabaseSubDbListSource | null): any {
    return value as any;
}

